import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';

const MIN_COL_WIDTH = 40;

const styles = theme => ({
  root: {
    height: '100%',
    width: 4,
    right: 0,
    top: 5,
    position: 'absolute',
    cursor: 'col-resize',
    background: 'transparent'
  },
  hovered: {
    borderRight: '2px solid',
    borderRightColor: theme.palette.primary.dark
  }
});

class Resizable extends Component {
  constructor(props) {
    super(props);
    this.target = null;
    this.offset = null;
    this.isResizing = false;
    this.element = React.createRef();
    this.isMouseDown = false;
    this.currentX = 0;
  }

  mouseDown = evt => {
    evt.preventDefault();
    const { cellRef } = this.props;
    const th = cellRef.current.parentNode;
    document.body.addEventListener('mousemove', this.mouseMove)
    document.body.addEventListener('mouseup', this.mouseUp)

    this.isResizing = true;
    this.target = evt.target;
    this.offset = th.getBoundingClientRect().width - evt.pageX;
    this.isMouseDown = true;
    this.props.onStart();
  }

  mouseMove = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    if (!this.isMouseDown) {
      return;
    }

    const minColWidth = MIN_COL_WIDTH;
    let x = evt.clientX + this.offset;
    if (x < minColWidth) {
      x = minColWidth;
    }

    this.currentX = x;
    this.resize(evt);
  }

  resize = (evt)  => {
    this.props.onResize(
      this.props.idx,
      this.currentX,
      evt.movementX
    );
  }

  mouseUp = evt => {
    evt.preventDefault();
    if (!this.isResizing) return;

    document.body.removeEventListener('mousemove', this.mouseMove);
    document.body.removeEventListener('mouseup', this.mouseUp);
    this.isMouseDown = false;
    this.props.onEnd()
  }

  render() {
    const { classes, cellRef } = this.props;
    const hoverClass = this.props.isHovered ?
      classnames(classes.root, [classes.hovered]):
      classes.root;

    return (
      <div
        role="gridcell"
        tabIndex="-1"
        className={hoverClass}
        ref={cellRef}
        onMouseDown={this.mouseDown}
        style={{ zIndex: 10 }}
      />
    )
  }
}

Resizable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Resizable);
